import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Typography } from 'antd';

import { requestLinks, requestTypes } from '../../../../settings/lab_exam_request/settings';

const { Text } = Typography;

class FormButtons extends React.Component {
	render() {
		const { isLoading } = this.props;
		const { create, edit } = requestLinks;
		const sessReqType = sessionStorage.getItem('REQUEST_TYPE');
		const dynamicLink =
			sessReqType === requestTypes.create || sessReqType === undefined ? create.step1 : edit.step1;

		return (
			<div className="base-form-button">
				<Link to={dynamicLink}>
					<Text>
						<u>BACK</u>
					</Text>
				</Link>
				<Button
					className="nav-btn-round"
					htmlType="submit"
					type="primary"
					loading={isLoading}
					style={{ marginLeft: 20 }}
				>
					NEXT STEP
				</Button>
			</div>
		);
	}
}

FormButtons.propTypes = {
	isLoading: PropTypes.bool.isRequired,
};

export default FormButtons;
